module.exports = __webpack_public_path__ + "static/img/empty-bookmark-textbook.8664483.svg";